import React, { useState } from "react";
import QueryBuilder from "../QueryBuilder/Querybuilder";
import logo from "../../assets/logo.png";
import { Button, Modal, Form, Input, Select, message, Row, Col } from "antd";
const Categories = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log("Form Values:", values);
    handleAddCategory(values);
  };

  const showModal = () => {
    setModalVisible(true);
  };

  const handleCancel = () => {
    setModalVisible(false);
    form.resetFields();
  };
  const handleAddCategory = async (values) => {
    const dataToSend = {
      name: values.category,
    };

    try {
      const response = await fetch("/api/portal/pms/add_pms_categories", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataToSend),
      });

      if (response.ok) {
        message.success("Source added successfully");
        setModalVisible(false);
        form.resetFields();
      } else {
        message.error("Failed to add source");
      }
    } catch (error) {
      message.error("Error adding source");
      console.error("Error:", error);
    }
  };
  return (
    <div>
      <Modal
        open={modalVisible}
        onOk={() => form.submit()}
        onCancel={handleCancel}
        title="Public Grievance Form"
        width={1000}
        style={{ top: 20, left: "6%" }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            src={logo}
            style={{ width: 60, marginRight: 20 }}
            alt="Pulse Logo"
          />
          <h2 style={{ margin: 0 }}>Janasena</h2>
        </div>
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ marginTop: 20 }}
        >
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="category"
                label="Add Category"
                rules={[
                  { required: true, message: "Please enter your category" },
                ]}
              >
                <Input placeholder="Enter your category" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
      <QueryBuilder
        title={"Category"}
        Headername={"/api/portal/reports/pms/getTablemetadata/50"}
        Rulesdata={"/api/portal/reports/pms/getFilters/50"}
        Databyquery={"/api/portal/reports/pms/getDatabyquery/50"}
        addcategory={true}
        addcategoryepet={showModal}
      />
    </div>
  );
};

export default Categories;
